// eslint-disable-next-line import/no-unresolved
import { useAppSelector } from "src/utils/hooks/useAppSelector";
import CustomReviewField from "../../../../../shared/CustomReviewField";
import CustomLabel from "../../../../../shared/CustomLabel";

function PremiumFundingReview() {
  const loanDetails = useAppSelector((state) => state.loanDetails);
  const premiumFundingMefFields = useAppSelector(
    (state) => state.masterdata_reducer?.mefJourneySchema?.planDetails
  );
  return (
    <div>
      <div className="flex justify-between mt-8">
        <div className="text-base font-bold">Premium Funding</div>
      </div>
      <div className="grid grid-flow-row-dense lg:grid-cols-3 grid-cols-2 gap-y-8 md:gap-x-28 gap-x-3 mt-6 max-sm:ml-4 ">
        {(loanDetails?.premiumFunding?.premiumFunding ||
          premiumFundingMefFields?.premiumFunding?.visible) && (
          <div className="col-span-1">
            <CustomLabel>{premiumFundingMefFields?.premiumFunding?.label}</CustomLabel>
            <CustomReviewField>
              {loanDetails?.premiumFunding?.premiumFunding || "-"}
            </CustomReviewField>
          </div>
        )}
      </div>
    </div>
  );
}
export default PremiumFundingReview;
